import { useState, useEffect } from 'react'
import { Grid, Typography, Card, CardContent } from '@material-ui/core'
import { PhoneInTalk, CallEnd, Person, Pause } from '@mui/icons-material'

import { withStyles } from '@material-ui/styles'
import styles from './agentsStyles'

import { httpRequest } from '../../../../ui-utils/api'
import { apiUrl } from '../../../../ui-utils/apiConfig'

import AgentsTable from './AgentsTable'
import CallersList from './CallersList'

const AgentsStats = ({ classes }) => {

    const [agentsList, setAgentsList] = useState([])
    const [agentsOnCall, setAgentsOnCall] = useState([])
    const [agentsIdle, setAgentsIdle] = useState([])
    // const [agentsUnknown, setAgentsUnkown] = useState([])
    const [agentsLogIn, setAgentsLogIn] = useState([]) // Srini - 05/12/24

    const [callList, setCallList] = useState(false)
    const [callTable, setCallTable] = useState(true)
    const [selectedCard, setSelectedCard] = useState('')

    useEffect(() => {
        const fetchData = async () => {
            try {
                const fsLiveResult = await httpRequest({
                    endPoint: `${apiUrl.fsLiveStats}`,
                    method: 'get',
                    instance: 'instanceOne'
                })

                if (fsLiveResult.success) {
                    const agentsResult = fsLiveResult.data.users.filter((item) => {
                        return !String(item.sip_id).startsWith('9')
                    })

                    const agentsOnCallResult = fsLiveResult.data.users.filter((item) => {
                        return (
                            !String(item.sip_id).startsWith('9') &&
                            item.presence === "I am with client call"
                        )
                    })

                    const agentsIdleResult = fsLiveResult.data.users.filter((item) => {
                        return (
                            !String(item.sip_id).startsWith('9') &&
                            item.presence === "I am Idle"
                        )
                    })

                    // const agentsUnknownResult = fsLiveResult.data.users.filter((item) => {
                    //     return (
                    //         !String(item.sip_id).startsWith('9') && 
                    //         item.presence === "" &&
                    //         Object.keys(item.fs_live).length > 0
                    //     )
                    // })

                    const agentLogInResult = fsLiveResult.data.users.filter((item) => {
                        return (
                            !String(item.sip_id).startsWith('9') &&
                            Object.values(item.fs_live).length > 0 &&
                            Object.values(item.ui_login).length > 0 &&
                            Object.values(item.presence).length > 0
                        )
                    }) // Srini - 05/12/24

                    setAgentsList(agentsResult)
                    setAgentsOnCall(agentsOnCallResult)
                    setAgentsIdle(agentsIdleResult)
                    // setAgentsUnkown(agentsUnknownResult)
                    setAgentsLogIn(agentLogInResult) // Srini - 05/12/24
                }
            } catch (error) {
                console.error("Error fetching data FS Live API:", error)
            }
        }

        fetchData()

        const intervalId = setInterval(fetchData, 30000)

        return () => clearInterval(intervalId)
    }, [])

    const handleCallList = (cardType) => {
        setCallList(true)
        setCallTable(false)
        setSelectedCard(cardType)
    }

    const handleCallTable = () => {
        setCallTable(true)
        setCallList(false)
        setSelectedCard('onCall')
    }

    const selectedCardStyle = {
        border: '2px solid #999',
        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
    }

    return (
        <Grid container style={{ margin: "7% 0 0 2%", }}>
            <Grid item xs={12}>
                <Typography className={classes.mntrTxt}>Monitoring</Typography>
            </Grid>
            {/* Srini - 05/12/24 */}
            <Grid container item justifyContent="center" xs={12} style={{ margin: "40px 0 0 0", }}>
                {/* Number of Callers Card */}
                <Grid item>
                    <Card className={classes.card} 
                    style={selectedCard === 'callerList' ? selectedCardStyle : {}}
                    onClick={() => handleCallList('callerList')}>
                        <CardContent>
                            <div className={classes.iconContainer}>
                                <PhoneInTalk className={`${classes.icon} ${classes.numberOfCallersIcon}`} />
                            </div>
                            <Typography className={classes.title}>Number of Callers</Typography>
                            <Typography className={classes.value}>{agentsList.length}</Typography>
                        </CardContent>
                    </Card>
                </Grid>

                {/* Log In Card - Srini - 05/12/24 */}
                <Grid item>
                    <Card className={classes.card} 
                    style={selectedCard === 'agentsLogIn' ? selectedCardStyle : {}}
                    onClick={() => handleCallList('agentsLogIn')}>
                        <CardContent>
                            <Person className={`${classes.icon} ${classes.breakIcon}`} />
                            <Typography className={classes.title}>Logged In</Typography>
                            <Typography className={classes.value}>{agentsLogIn.length}</Typography>
                        </CardContent>
                    </Card>
                </Grid>

                {/* On Call Card */}
                <Grid item>
                    <Card className={classes.card} 
                    style={selectedCard === 'onCall' ? selectedCardStyle : {}}
                    onClick={handleCallTable}>
                        <CardContent>
                            <CallEnd className={`${classes.icon} ${classes.onCallIcon}`} />
                            <Typography className={classes.title}>On Call</Typography>
                            <Typography className={classes.value}>{agentsOnCall.length}</Typography>
                        </CardContent>
                    </Card>
                </Grid>

                {/* Idle Card */}
                <Grid item>
                    <Card className={classes.card} 
                    style={selectedCard === 'agentsIdle' ? selectedCardStyle : {}}
                    onClick={() => handleCallList('agentsIdle')}>
                        <CardContent>
                            <Person className={`${classes.icon} ${classes.idleIcon}`} />
                            <Typography className={classes.title}>Idle</Typography>
                            <Typography className={classes.value}>{agentsIdle.length}</Typography>
                        </CardContent>
                    </Card>
                </Grid>
            </Grid>

            <Grid item xs={12}>
                {callTable && <AgentsTable />}
                {callList && (
                    selectedCard === 'callerList' ? (
                        <CallersList agentsList={agentsList} />
                    ) : selectedCard === 'agentsIdle' ? (
                        <CallersList agentsList={agentsIdle} />
                    ) : selectedCard === 'agentsLogIn' ? (
                        <CallersList agentsList={agentsLogIn} />
                    ) : null
                )}
            </Grid>

        </Grid>
    )
}

export default withStyles(styles)(AgentsStats)